import {React, useState, cloneElement}from 'react';
import { Link, useNavigate } from 'react-router-dom';
import {Auth} from 'aws-amplify';
import Drawer from '@mui/material/Drawer';
import Divider from '@mui/material/Divider';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemButton from '@mui/material/ListItemButton'
import ListItemText from '@mui/material/ListItemText';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import MyLocationIcon from '@mui/icons-material/MyLocation';
import InventoryIcon from '@mui/icons-material/Inventory';
import ListAltIcon from '@mui/icons-material/ListAlt';
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import GridViewIcon from '@mui/icons-material/GridView';
import CancelScheduleSendIcon from '@mui/icons-material/CancelScheduleSend';
import CollectionsBookmarkIcon from '@mui/icons-material/CollectionsBookmark';
import CloudSyncIcon from '@mui/icons-material/CloudSync';
import MonitorHeartIcon from '@mui/icons-material/MonitorHeart';
import AssessmentIcon from '@mui/icons-material/Assessment';
import BuildCircleIcon from '@mui/icons-material/BuildCircle';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import PauseCircleOutlineIcon from '@mui/icons-material/PauseCircleOutline';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import GetAppIcon from '@mui/icons-material/GetApp';
import ViewModuleIcon from '@mui/icons-material/ViewModule';
import BookIcon from '@mui/icons-material/Book';
import BallotIcon from '@mui/icons-material/Ballot';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import SearchIcon from '@mui/icons-material/Search';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import SensorOccupiedIcon from '@mui/icons-material/SensorOccupied';
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import BugReportIcon from '@mui/icons-material/BugReport';
import WarehouseIcon from '@mui/icons-material/Warehouse';
import TrackChangesIcon from '@mui/icons-material/TrackChanges';
import TimeLineOutlinedIcon from '@mui/icons-material/TimelineOutlined';
import ReceiptIcon from '@mui/icons-material/Receipt';
import ControlPointIcon from '@mui/icons-material/ControlPoint';
import Warehouses from './Warehouses';
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography';
import Collapse from '@mui/material/Collapse';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import LoginIcon from '@mui/icons-material/Login';


import '../../css/Sidebar.css'


function Sidebar(props) {

    const [hover, setHover] = useState(-1);
    const navigate = useNavigate();

    function setClasses(item) {
      if(item === props.route) {
        return `listItem ${props.company} ${props.warehouse} active`
      } else {
        return `listItem ${props.company} ${props.warehouse}`
      }
    }

    const logOut = async() => {
      await Auth.signOut();
      props.clearUser();
      navigate('/login');
    }

    const pages = [
      {
        type: "Dropship",
        pages: [{
          title: "uploads",
          text: "Uploads",
          scopes: ["admin", "dropship"],
          link: "/uploads",
          icon: <UploadFileIcon />

        },
        {
          title: "api_status",
          text: "API Status",
          scopes: ["admin", "dropship"],
          link: "/api_status",
          icon: <CloudUploadIcon />
        },
        {
          title: "failed_tracking",
          text: "Failed Tracking",
          scopes: ["admin", "dropship"],
          link: "/failed_tracking",
          icon: <CancelScheduleSendIcon />
        },
        {
          title: "on_hold",
          text: "On Hold",
          scopes: ["admin", "dropship"],
          link: "/on_hold",
          icon: <PauseCircleOutlineIcon />
        },
        {
          title: "pullsheets",
          text: "Pull Sheets",
          scopes: ["admin", "dropship"],
          link: "/pullsheets",
          icon: <ListAltIcon />
        },
        {
          title: "order_search",
          text: "Order Search",
          scopes: ["admin", "dropship", "warranties"],
          link: "/order_search",
          icon: <SearchIcon />
        },
        {
          title: "ds_export",
          text: "Export",
          scopes: ["admin", "dropship", "warranties"],
          link: "/ds_export",
          icon: <GetAppIcon />
        },
        {
          title: "warehouse_priority",
          text: "WH Priority",
          scopes: ["admin", "dropship"],
          link: "/warehouse_priority",
          icon: <WarehouseIcon />
        },
        {
          title: "usps_scan_form",
          text: "USPS Scan Forms",
          scopes: ["dropship"],
          link: "/usps_scan_form",
          size: "13px",
          icon: <SensorOccupiedIcon />
        }]
      },
      {
        type: "Bulk",
        pages: [
          {
            title: "bulk_orders",
            text: "Bulk Orders",
            scopes: ["admin", "bulk"],
            link: "/bulk_orders",
            icon: <AddShoppingCartIcon />
          },
          {
            title: "bulk_uploads",
            text: "Bulk Uploads",
            scopes: ["admin", "bulk"],
            link: "/bulk_uploads",
            icon: <CloudSyncIcon />
          },
          {
            title: "bulk_status",
            text: "Bulk Status",
            scopes: ["admin", "bulk"],
            link: "/bulk_status",
            icon: <MonitorHeartIcon />
          },
          {
            title: "bulk_invoices",
            text: "Invoices",
            scopes: ["admin", "bulk"],
            link: "/bulk_invoices",
            icon: <FileCopyIcon />
          },
          {
            title: "lots",
            text: "Lots",
            scopes: ["admin", "bulk"],
            link: "/lots",
            icon: <BallotIcon />
          },
          {
            title: "bulk_carriers",
            text: "Carriers",
            scopes: ["admin", "bulk"],
            link: "/bulk_carriers",
            icon: <LocalShippingIcon />
          },
          {
            title: "bulk_pullsheets",
            text: "Pull Sheets",
            scopes: ["admin", "bulk"],
            link: "/bulk_pullsheets",
            icon: <ListAltIcon />
          },
          {
            title: "bulk_search",
            text: "Order Search",
            scopes: ["admin", "bulk"],
            link: "/bulk_search",
            icon: <SearchIcon />
          },
          {
            title: "box_labels",
            text: "Box Labels",
            scopes: ["admin", "bulk", "inventory"],
            link: "/box_labels",
            icon: <BookIcon />
          },
          {
            title: "pallet_labels",
            text: "Pallet Labels",
            scopes: ["admin", "bulk", "inventory"],
            link: "/pallet_labels",
            icon: <ViewModuleIcon />
          },
          {
            title: 'bulk_change',
            text: "Change Requests",
            scopes: ["admin", "washington"],
            link: "/bulk_change",
            size: "13px",
            icon: <TrackChangesIcon />
          },
          {
            title: 'shipping_dash',
            text: "Shipping Dashboard",
            scopes: ["admin", "bulk"],
            link: "/shipping_dash",
            size: "12px",
            icon: <GridViewIcon />
          }, {
            title: 'carrier_sign_in',
            text: "Carrier Sign-In",
            scopes: ["carrier-sign-in"],
            link: "/carrier_sign_in",
            size: "12px",
            icon: <LoginIcon />
          }, {
            title: 'carrier_sign_in_dashboard',
            text: "Carrier Sign-In Dashboard",
            scopes: ["bulk"],
            link: "/carrier_sign_in_dashboard",
            size: "12px",
            icon: <AccessTimeIcon />
          }
      ]},
      {
        type: 'Warranty',
        pages: [
          {
            title: "warranty_insert",
            text: "Warranty Insert",
            scopes: ["admin", "warranties"],
            link: "/warranty_insert",
            icon: <ControlPointIcon />
          },
          {
            title: "warranty_search",
            text: "Order Search",
            scopes: ["admin", "warranties"],
            link: "/warranty_search",
            icon: <SearchIcon />
          },
          {
            title: "warranty_graphs",
            text: "Graphs",
            scopes: ["admin", "warranties"],
            link: "/warranty_graphs",
            icon: <AssessmentIcon />
          }
      ]},
      {
        type: "Warehouse",
        pages: [
          {
            title: "employee_times",
            text: "Worker Times",
            scopes: ["admin", "warehouse"],
            link: "/employee_times",
            icon: <AccessTimeIcon />
          },
          {
            title: "daily_builds",
            text: "Daily Builds",
            scopes: ["admin", "warehouse"],
            link: "/daily_builds",
            icon: <WarehouseIcon />
          },
          {
            title: "efficiency_report",
            text: "Efficiency",
            scopes: ["admin", "warehouse"],
            link: "/efficiency_report",
            icon: <AssessmentIcon />
          },
          {
            title: "hourly_builds",
            text: "Hourly Builds",
            scopes: ["admin", "warehouse"],
            link: "/hourly_builds",
            icon: <TimeLineOutlinedIcon />
          },
          {
            title: "production_calendar",
            text: "Production Calendar",
            scopes: ["admin", "warehouse"],
            link: "/production_calendar",
            icon: <CalendarMonthIcon />
          }
        ]
      },
      {
        type: "Utility",
        pages: [{
          title: "inventory",
          text:"Inventory",
          scopes: ["admin", "inventory"],
          link: "/inventory",
          icon: <InventoryIcon />
        },
        {
          title: "extract_text",
          text:"Extract Text",
          scopes: ["bulk"],
          link: "/extract_text",
          icon: <PictureAsPdfIcon />
        }, 
        {
          title: "vendor_stickers",
          text: "Vendor Stickers",
          scopes: ["bulk"],
          link: "/vendor_stickers",
          size: "13px",
          icon: <CollectionsBookmarkIcon />
        },
        {
          title: "transaction_report",
          text: "EDI Transactions",
          scopes: ["bulk"],
          link: "/transaction_report",
          size: "13px",
          icon: <ReceiptLongIcon />
        }]},
        

      {
        type: "Acumatica",
      pages:[{
          title: "acumatica_upload",
          text:"Upload",
          scopes: ["admin", "acumatica"],
          link: "/acumatica_uploads",
          icon: <UploadFileIcon />
        },
      {
        title: "autobuild",
        text:"AutoBuild",
        scopes: ["admin", "acumatica"],
        link: "/autobuild",
        icon: <BuildCircleIcon />
      },
      {
        title: "invoices",
        text:"Invoices",
        scopes: ["admin", "acumatica"],
        link: "/invoices",
        icon: <ReceiptIcon />
      }]},
      {
        type: "Admin",
        pages:[{
        title: "users",
        text: "Users",
        scopes: ["admin"],
        link: "/users",
        icon: <SupervisorAccountIcon />
      },
      {
        title: "log",
        text: "Log",
        scopes: ["admin"],
        link: "/log",
        icon: <MyLocationIcon />
      }
    ]
  }]

    return(
      <Drawer
        variant={props.isMobile ? 'temporary' : 'permanent'}
        ModalProps={{keepMounted: true}}
        anchor='left'
        sx={{width: '200px', flexShrink: 0,  zIndex: props.zIndex}}
        open={props.open}
        onClose={() => props.toggle(false)}
      >
        <List style={{paddingTop:"0", width:"100%"}}>
          <Box display="flex">
            <ListItem onClick={()=>props.toggle(false)} component={Link} to="/" sx={{height:"50px", padding:"0"}} className={`${props.company} ${props.warehouse} ${props.is_sandbox ? "sandbox" : ""} primary`}>
                <Typography variant='h4' style={{color:"white", fontFamily:"Century Gothic", fontWeight: "bold", margin:"auto", height:"fit-content"}}>{props.is_sandbox ? "SANDBOX" : "IMSv2"}</Typography>
            </ListItem>
          </Box>
          </List>
          <List id="scrollmenu" style={{paddingTop:"0",overflowY:"scroll",overflowX:"hidden", width: '200px'}}>

          {props.isMobile ? 
            <Warehouses {...props} />
            : null
          }
          {pages.map((outer, index) => {
            let page_types = pages.map(obj=>obj.pages).filter(obj => {
              for(let row of obj) {
                if(!row.scopes || props.scopes.some(ele => row.scopes.includes(ele))) return true;
              }
              return false;
            });
            let row_count = page_types.reduce((a, b) => a + b.length, 0)
            let menu_items = outer.pages.map((obj, inner) => {
              let inScope = props.scopes.some(ele => {
                return !obj.scopes || obj.scopes.includes(ele)
              });
              let inner_index = index * 100 + inner;
              if(inScope) {
                return(
                  <Box key={inner_index}>
                    <ListItem  onMouseOver={() => setHover(inner_index)} onMouseLeave={() => setHover(-1)} onClick={()=>props.toggle(false)} className={setClasses(obj.title)} component={Link} to={obj.link}>
                      <ListItemIcon>
                        {cloneElement(obj.icon, {sx:{color:hover === inner_index ? "white" : ""}})}
                      </ListItemIcon>
                      <ListItemText primaryTypographyProps={{fontSize: obj.size ? obj.size : null}} primary={obj.text}></ListItemText>
                    </ListItem>
                    <Divider />
                  </Box>
                )
              }
            })
            if(menu_items.every(obj => !obj)) return null;
            return (
              <Box key={index} sx={{paddingBottom:"5px"}}>
                <ListItemButton onClick={() => props.handleSubMenuClick(outer.type)} style={{backgroundColor:"#f1eeee"}}>
                  <Typography variant="h6" style={{width:"100%", padding:"0"}}>
                    {outer.type}
                  </Typography>
                </ListItemButton>
                {page_types.length > 3 && row_count > 9 ? <Collapse timeout="auto" in={props.openSubMenus[outer.type]} unmountOnExit>
                  {menu_items}
                </Collapse> : menu_items }
              </Box>
            )
          })}
          </List>
          <List style={{marginTop: 'auto'}}>
          <Divider />
          <ListItem  onMouseOver={() => setHover(pages.length + 1)} onMouseLeave={() => setHover(-1)} onClick={()=>props.toggle(false)} className={setClasses("bugreport")} component={Link} to={"/bugreport"}>
              <ListItemIcon>
                <BugReportIcon sx={{color:hover === pages.length + 1 ? "white" : ""}} />
              </ListItemIcon>
              <ListItemText primary="Report Error"></ListItemText>
            </ListItem>
            <Divider />          
            <ListItem onMouseOver={() => setHover(pages.length + 2)} onMouseLeave={() => setHover(-1)} className={setClasses('signout')} onClick={() => logOut()} >
            <ListItemIcon>
              <SupervisorAccountIcon sx={{color:hover === pages.length + 2 ? "white" : ""}} />
            </ListItemIcon>
            <ListItemText primary='Sign Out'></ListItemText>
          </ListItem>
        </List>
      </Drawer>
    )
}

export default Sidebar;